import { Component, ElementRef, HostListener } from '@angular/core';
import { UidName } from '@airwallet/shared-models/misc';
import { LoadingComponent } from '@components/loading/loading.component';
import { SamlService } from '@services/auth/saml.service';

@Component({
    selector: 'app-owner-selector',
    imports: [LoadingComponent],
    templateUrl: './owner-selector.component.html',
    styleUrl: './owner-selector.component.scss'
})
export class OwnerSelectorComponent {
    public isOpen = false;

    constructor(
        private elementRef: ElementRef,
        protected samlService: SamlService
    ) {}

    get selectedOption(): UidName | undefined {
        return this.samlService.samlMembershipOwners()?.find(option => option.uid === this.samlService.chosenUid());
    }

    toggleDropdown(): void {
        this.isOpen = !this.isOpen;
    }

    async selectOption(option: UidName): Promise<void> {
        this.samlService.chosenUid.set(option.uid);
        this.isOpen = false;
        await this.samlService.changeDashboard();
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent): void {
        if (!this.elementRef.nativeElement.contains(event.target)) {
            this.isOpen = false;
        }
    }
}
